var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.688,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1346",
    d: "M13.442 25H7.534V7.449h5.908v.514a7.67 7.67 0 015.822.514h.086a7.063 7.063 0 013.339 5.993v10.36h-5.908V14.469a1.184 1.184 0 00-.428-.769 2.092 2.092 0 00-1.453 0l-1.455.771zm-4.624-1.284h3.339v-10.1l2.227-1.116a3.864 3.864 0 012.4-.086h.171l.086.086a2.632 2.632 0 011.027 1.884v9.246H21.4v-9.075a5.818 5.818 0 00-2.74-4.88A6.66 6.66 0 0013.1 9.5l-.856.428v-1.2H8.818zM6.421 25H.6V7.449h5.907V25zm-4.537-1.284h3.339V8.733H1.884zM3.51 7.021A3.472 3.472 0 010 3.51 3.472 3.472 0 013.51 0a3.545 3.545 0 013.6 3.51 3.545 3.545 0 01-3.6 3.511zm0-5.736A2.211 2.211 0 001.284 3.51 2.211 2.211 0 003.51 5.736 2.285 2.285 0 005.822 3.51 2.285 2.285 0 003.51 1.284z",
    fill: "#555"
  })));
}

export default __webpack_public_path__ + "static/media/linkedin_sm.400e7a8406a71dd6ac8a0e97873b3289.svg";
export { SvgLinkedinSm as ReactComponent };